import React, { useEffect, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { Avatar, Box, Button, ButtonBase, Grid } from '@material-ui/core';
import ImportExport from '@material-ui/icons/ImportExport';
import styled from 'styled-components';
import { get, isEmpty } from 'lodash';
import EnhancedTable from './tableReception/EnhancedTable';
import { getReception, exportReception } from './receptionsActions';
import { Title } from '../style';
import { statesCodesColor } from '../operations/binding';

const Label = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #8c9aa6;
  width: 200px;
  text-align: right;
`;

const Value = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #56636c;
  margin-left: 8px;
`;

const Container = styled.div`
  display: flex;
  margin-left: 14px;
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  background-color: #d2d2d2;
`;

const CustomAvatar = styled(Avatar)`
  width: 64px;
  height: 64px;
  background-color: ${props => props.color};
  font-weight: bold;
`;

const Reception = ({
  dispatchGetReception,
  dispatchExportReception,
  reception
}) => {
  const { receptionId } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  useEffect(() => {
    dispatchGetReception(receptionId);
  }, [dispatchGetReception, receptionId]);

  if (isEmpty(reception)) {
    return <div />;
  }

  const handleClick = () => {
    dispatchExportReception(receptionId);
  };

  return (
    <>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Title>Réception marchandise n° {receptionId}</Title>
        <Button color="primary" variant="contained" onClick={handleClick}>
          Exporter
          <ImportExport />
        </Button>
      </Box>
      <Box mt={2}>
        <Grid container>
          <Grid item lg={3} md={4} sm={6}>
            <Box display="flex" alignItems="center">
              <CustomAvatar
                size="large"
                color={statesCodesColor[get(reception, 'state.code')]}
              >
                {Math.round(
                  (reception.actualNumberOfProducts * 100) /
                    reception.expectedNumberOfProducts
                )}{' '}
                %
              </CustomAvatar>
              <Box fontWeight={700} ml={2}>
                Marchandise en cours de contrôle <br />{' '}
                {reception.actualNumberOfProducts} produits contrôlés sur{' '}
                {reception.expectedNumberOfProducts} au total
              </Box>
            </Box>
          </Grid>
          <Grid item lg={3} md={4} sm={6}>
            <Box display="flex" flexDirection="column">
              <Container>
                <Label style={{ width: 120 }}>Référence :</Label>
                <Value>{get(reception, 'reference', '-')}</Value>
              </Container>
              <Container>
                <Label style={{ width: 120 }}>Description :</Label>
                <Value>{get(reception, 'description', '-')}</Value>
              </Container>
              <Container>
                <Label style={{ width: 120 }}>Transporteur :</Label>
                <Value>{get(reception, 'carrierName', '-')}</Value>
              </Container>
              <Container>
                <Label style={{ width: 120 }}>Numéro de suivi :</Label>
                <Value>{get(reception, 'trackingNumber', '-')}</Value>
              </Container>
            </Box>
          </Grid>
          <Grid item md={4} sm={6}>
            <Container>
              <Label>Livraison :</Label>
              <Value>
                {reception.actualDeliveryDate
                  ? `${moment(reception.actualDeliveryDate).format(
                      'DD/MM/YYYY'
                    )} (annoncée le ${moment(
                      reception.expectedDeliveryDate
                    ).format('DD/MM/YYYY')})`
                  : `annoncée le ${moment(
                      reception.expectedDeliveryDate
                    ).format('DD-MM-YYYY')}`}
              </Value>
            </Container>
            <Container>
              <Label>Palettes :</Label>
              <Value>
                {reception.actualNumberOfPallets
                  ? `${reception.actualNumberOfPallets} sur
                ${reception.expectedNumberOfPallets} prévus`
                  : `${reception.expectedNumberOfPallets} prévus`}
              </Value>
            </Container>
            <Container>
              <Label>Colis en palette :</Label>
              <Value>
                {reception.actualNumberOfPackagesInPallet
                  ? `${reception.actualNumberOfPackagesInPallet} sur
                ${reception.expectedNumberOfPackagesInPallet} prévus`
                  : `${reception.expectedNumberOfPackagesInPallet} prévus`}
              </Value>
            </Container>
            <Container>
              <Label>Colis en vrac :</Label>
              <Value>
                {reception.actualNumberOfPackagesInBulk
                  ? `${reception.actualNumberOfPackagesInBulk} sur
                ${reception.expectedNumberOfPackagesInBulk} prévus`
                  : `${reception.expectedNumberOfPackagesInBulk} prévus`}
              </Value>
            </Container>
          </Grid>
          <Grid item md={2} sm={6}>
            <Box>
              {reception.picturesUrls &&
                reception.picturesUrls.slice(0, 3).map((picturesUrl, index) => (
                  <ButtonBase
                    key={picturesUrl}
                    onClick={() => {
                      setPhotoIndex(index);
                      setIsOpen(true);
                    }}
                  >
                    <Image src={picturesUrl} />
                  </ButtonBase>
                ))}
            </Box>
          </Grid>
          {isOpen && (
            <Lightbox
              reactModalStyle={{ overlay: { zIndex: 2100 } }}
              mainSrc={reception.picturesUrls[photoIndex]}
              nextSrc={
                reception.picturesUrls[
                  (photoIndex + 1) % reception.picturesUrls.length
                ]
              }
              prevSrc={
                reception.picturesUrls[
                  (photoIndex + reception.picturesUrls.length - 1) %
                    reception.picturesUrls.length
                ]
              }
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex(
                  (photoIndex + reception.picturesUrls.length - 1) %
                    reception.picturesUrls.length
                )
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % reception.picturesUrls.length)
              }
            />
          )}
        </Grid>
      </Box>
      <EnhancedTable reception={reception} />
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchGetReception: params => dispatch(getReception(params)),
  dispatchExportReception: receptionId => dispatch(exportReception(receptionId))
});

const mapStateToProps = state => ({
  reception: state.receptions.currentReception
});

Reception.propTypes = {
  dispatchGetReception: PropTypes.func,
  dispatchExportReception: PropTypes.func,
  reception: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reception);
